import { HotelSortViewPropertiesType } from "@website/accommodation-ui/hotel-list-header/hotel-sort-view/hotel-sort-view.types";
import { MaterialIcon } from "@website/icons/material";
import toString from "lodash-es/toString";
import { useCallback, useEffect, useState } from "react";

export const useHotelSortView = (properties: HotelSortViewPropertiesType) => {
  const { list, initialValue, popoverProps, buttonProps, onChange } =
    properties;
  const [isDirty, setIsDirty] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const [result, setResult] = useState<
    | {
        label: string;
        value: string;
      }
    | undefined
  >();

  useEffect(() => {
    setResult(list.find((item) => item.value === (initialValue || "selling")));
  }, [initialValue, list]);

  const onClickChips = useCallback(() => {
    setOpen(true);
  }, []);
  const onClosePopover = useCallback(() => {
    setOpen(false);
  }, []);
  const onChangeRadio = useCallback(
    (response: any) => {
      const item = list.find(
        (element) => element.value === response.target.value
      );
      setIsDirty(true);
      setResult(item);
      onChange?.(item?.value);
      onClosePopover();
    },
    [onClosePopover, list, onChange]
  );

  const getLabelText = useCallback(
    () =>
      toString(
        !isDirty && !initialValue
          ? "مرتب‌سازی"
          : (!isDirty && initialValue) || isDirty
            ? result?.label
            : ""
      ),
    [isDirty, initialValue, result?.label]
  );

  return {
    buttonProps: {
      size: "small" as const,
      children: getLabelText(),
      variant: "round-outline" as const,
      StartIcon: <MaterialIcon className="text-sm" name="sort" />,
      color: "neutral" as const,
      onClick: onClickChips,
      ...buttonProps
    },
    popoverProps: {
      onClose: onClosePopover,
      open,
      title: "مرتب‌سازی",
      defaultHorizontalPosition: "end" as const,
      ...popoverProps
    },
    radioProps: {
      list,
      checkedRadio: result?.value,
      onChangeRadio
    }
  };
};
